// Module
var code = "<div class=\"search-bar-container\"> <wt-generic-search-bar criteria=\"vm.criteria\" filtered-items=\"vm.filteredMiniatures\" items=\"vm.miniatures\" placeholder=\"Search for a widget (n:name c:comments)\"> </wt-generic-search-bar> </div>";
// Exports
module.exports = code;